import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import { Link } from "react-router-dom";

const DepartureImagePop = ({ tmsOdrNo, type }) => {
  //출발보고 URL 검색 URL
  let SERARCH_IMAGE_URL1 = "";
  let SERARCH_IMAGE_URL2 = "";
  //const IMAGE_URL = "http://tms.idaehan.com:8080/rn/rest/depart/getOrgAttachImage/" + tmsOdrNo;
  const IMAGE_URL =
    "https://tms.idaehan.com:8443/rn/rest/depart/getOrgAttachImage/" + tmsOdrNo;

  if (type === "image") {
    SERARCH_IMAGE_URL1 = IMAGE_URL + "/DPRT_01.do";
    SERARCH_IMAGE_URL2 = IMAGE_URL + "/DPRT_02.do";
  } else {
    SERARCH_IMAGE_URL1 = IMAGE_URL + "/ARRV_01.do";
    SERARCH_IMAGE_URL2 = IMAGE_URL + "/ARRV_02.do";
  }
  const [show, setShow] = useState(true);

  const handleClose = (returnData) => {
    setShow(false);
  };

  const handleOk = (returnData) => {
    setShow(false);
  };

  return (
    <>
      <Modal show={show} onHide={() => handleClose(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {type === "image" ? "출발보고 사진" : "도로영수증 사진"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="searchdata">
            <table className="t_garo">
              <tr>
                <th style={{ textAlign: "center", padding: "0" }}>
                  {type === "image" ? "출발보고 사진1" : "도로영수증 사진1"}
                  <Link
                    to="#"
                    onClick={() => window.open(SERARCH_IMAGE_URL1, "_blank")}
                  >
                    [사진 링크]
                  </Link>
                </th>
              </tr>
              <tr>
                <td style={{ padding: "0" }}>
                  <div id="map_div" style={{ textAlign: "center" }}>
                    <img
                      src={SERARCH_IMAGE_URL1}
                      style={{ width: "400px", height: "300px" }}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th style={{ textAlign: "center", padding: "0" }}>
                  {type === "image" ? "출발보고 사진2" : "계량증명서 사진2"}
                  <Link
                    to="#"
                    onClick={() => window.open(SERARCH_IMAGE_URL2, "_blank")}
                  >
                    [사진 링크]
                  </Link>
                </th>
              </tr>
              <tr>
                <td style={{ padding: "0" }}>
                  <div id="map_div" style={{ textAlign: "center" }}>
                    <img
                      src={SERARCH_IMAGE_URL2}
                      onError="this.style.display='none'"
                      style={{ width: "400px", height: "300px" }}
                    />
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => handleOk(true)}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const ModalDepartureImagePop = createModal(DepartureImagePop);

export default DepartureImagePop;
